import { Loader, Warning } from '@nosinovacao/fe-icons';
import { Button, If, useI18n } from '@nosinovacao/nosid-mfe-common';
import { type ActiveSessionsProps } from '../-model/props';

export function ActiveSessionsLight({
  onCancel,
  onConfirm,
  isLoading,
}: Readonly<ActiveSessionsProps>) {
  const { t } = useI18n();
  return (
    <div className="grid h-full grid-rows-[1fr_max-content] gap-8 pb-4">
      <div className="grid h-max gap-2 self-center break-words">
        <Warning width={48} height={48} className="text-nos-red" />
        <span
          data-tid="title-terminate-sessions"
          className="font-bold text-nos-neutral-1000 font-title-h3"
        >
          {t('ActiveSessions.Alert.Title')}
        </span>
        <span
          data-tid="text-terminate-sessions-description"
          className="text-nos-neutral-700 font-text-p1"
        >
          {t('ActiveSessions.Alert.Description')}
        </span>
      </div>
      <div className="grid gap-4 tablet:grid-cols-[max-content_max-content] tablet:gap-2">
        <Button
          data-tid="button-cancel"
          skin="light"
          variant="secondary"
          className="tablet:order-1"
          disabled={isLoading}
          onClick={onCancel}
        >
          {t('ActiveSessions.Alert.Cancel')}
        </Button>
        <Button
          data-tid="button-confirm-terminate"
          skin="light"
          destructive
          className="tablet:min-w-44"
          disabled={isLoading}
          onClick={onConfirm}
        >
          <If condition={isLoading}>
            <Loader height={24} width={24} />
          </If>
          <If condition={!isLoading}>{t('ActiveSessions.Alert.Confirm')}</If>
        </Button>
      </div>
    </div>
  );
}
